import React from 'react';
import { DialogV2 } from '@withjoy/joykit';
import { Box, ButtonV2, LinkV2, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

interface Props
  extends Readonly<{
    isOpen: boolean;
    onClose: () => void;
  }> {}

export const MustLeaveEvents: React.FC<Props> = props => {
  const { isOpen, onClose } = props;
  const { t } = useTranslation('account');

  return (
    <DialogV2
      id="MustLeaveEventsDialog"
      onClose={onClose}
      isOpen={isOpen}
    >
      <DialogV2.Header>
        <TextV2 typographyVariant="hed1">{t('mustLeaveEvents', 'title')()}</TextV2>
      </DialogV2.Header>
      <DialogV2.Body>
        <Box
          display="flex"
          flexDirection="column"
          paddingY={4}
        >
          <TextV2 typographyVariant="body1">
            {t('mustLeaveEvents', 'message')()} <LinkV2 typographyVariant="body1">{t('mustLeaveEvents', 'linkText')()}</LinkV2>
          </TextV2>
        </Box>
      </DialogV2.Body>
      <DialogV2.Footer>
        <ButtonV2
          intent="primary"
          onClick={onClose}
        >
          {t('mustLeaveEvents', 'confirmButton')()}
        </ButtonV2>
      </DialogV2.Footer>
    </DialogV2>
  );
};
